import styled from "@emotion/styled";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import React from "react";
import { IconButton, InputAdornment } from "@mui/material";

export const TogglePasswordIcon = (props: ITogglePasswordIcon) => {
  const { handleToggle, showPassword } = props;
  return (
    <InputAdornmentCustom position="end">
      <IconButton
        className="button"
        aria-label="toggle password visibility"
        onClick={handleToggle}
      >
        {showPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
      </IconButton>
    </InputAdornmentCustom>
  );
};

interface ITogglePasswordIcon {
  handleToggle: () => void;
  showPassword: boolean;
}

const InputAdornmentCustom = styled(InputAdornment)``;
